module.exports = __webpack_public_path__ + "static/media/dandy-interest.2f08f9d4.png";